
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const AdvancedTab = ({ formData, setFormData }) => {
  // Generate pass percentage options from 5 to 100 in increments of 5
  const passPercentageOptions = [];
  for (let i = 5; i <= 100; i += 5) {
    passPercentageOptions.push(i);
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="language">Language</Label>
          <Select
            value={formData.language}
            onValueChange={(value) =>
              setFormData((prev) => ({ ...prev, language: value }))
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="English">English</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Label htmlFor="passPercentage">Pass Percentage</Label>
          <Select
            value={formData.passPercentage?.toString()}
            onValueChange={(value) =>
              setFormData((prev) => ({ ...prev, passPercentage: parseInt(value) }))
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Select pass percentage" />
            </SelectTrigger>
            <SelectContent>
              {passPercentageOptions.map((percentage) => (
                <SelectItem key={percentage} value={percentage.toString()}>
                  {percentage}%
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      {formData.proctoring.enabled && (
        <div>
          <Label htmlFor="capture-frequency">
            Capture Frequency (seconds)
          </Label>
          <Input
            id="capture-frequency"
            type="number"
            min="10"
            value={formData.proctoring.captureFrequency / 1000}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                proctoring: {
                  ...prev.proctoring,
                  captureFrequency: parseInt(e.target.value) * 1000,
                },
              }))
            }
          />
        </div>
      )}
    </div>
  );
};

export default AdvancedTab;